import { FormError } from "app/containers/types";
import { Answer, LocalAnswer, MultiAnswerTypes, QuestionsForm, SingleAnswerTypes } from "../../types";
import { isValidURL } from "utils/helpers";
import { VALID_CHARS_REGEX_FOR_MIXED_LETTER } from "./components/QuestionTypes/components/MixedLetters/constants";

export const validateQuestion = (values: QuestionsForm, answer: LocalAnswer) => {
  const errors: Array<FormError> = [];
  if (!values.body.value) {
    errors.push({ name: "body", error: "QUESTIONS.ERRORS.BODY_IS_REQUIRED" });
  }

  if (!values.name.value) {
    errors.push({ name: "name", error: "QUESTIONS.ERRORS.NAME_IS_REQUIRED" });
  }

  if (values.score.value && Number(values.score.value) > 256 ) {
    errors.push({ name: "score", error: "QUESTIONS.ERRORS.SCORE_MAX_LIMIT" });
  }
  if (values.showLink.value == true || values.showLink.value == 'true') {
    if (!values.linkLabel.value) {
      errors.push({
        name: "linkLabel",
        error: "QUESTIONS.ERRORS.LINK_LABEL_IS_REQUIRED",
      });
    }
    
    if (!values.link.value) {
      errors.push({ name: "link", error: "QUESTIONS.ERRORS.LINK_IS_REQUIRED" });
    } else {
      if(String(values.link.value).trim().length) {
        if (!isValidURL(values.link.value)) {
          errors.push({
            name: "link",
            error: "QUESTIONS.ERRORS.LINK_SHOULD_BE_VALID",
          });
        }
        
        if (!values.link.value.startsWith("https")) {
          errors.push({
            name: "link",
            error: "QUESTIONS.ERRORS.LINK_SHOULD_START_WITH_HTTP",
          });
        }
    }
    }

      
    
  }
  if (values.type.value === "single_select") {
    // @ts-ignore
    const correctAnswers = answer.single_select?.filter((a) => a?.isCorrect) || [];
    if (correctAnswers.length !== 1) {
      errors.push({
        name: "answer",
        error: "QUESTIONS.ERRORS.SELECT_ONE_CORRECT_ANSWER",
      });
    }

     const value: SingleAnswerTypes =
        (answer.single_select?.[0]?.answer as SingleAnswerTypes) ||
        "TEXT_WITH_IMAGES";
      const isImagesType = value == "ONLY_IMAGES" 
      const isTextType = value == "ONLY_TEXT";
      const isTextWithImagesType = value == "TEXT_WITH_IMAGES";

      if(correctAnswers.length){
        if (isImagesType && !correctAnswers[0].asset?.url) {
          errors.push({
            name: "answer",
            error: "QUESTIONS.ERRORS.PLEASE_FILL_SELECTED_ANSWER_IMAGE",
          });  
        }

        if (isTextType && !correctAnswers[0].title ) {
          errors.push({
            name: "answer",
            error: "QUESTIONS.ERRORS.PLEASE_FILL_SELECTED_ANSWER_TITLE",
          });  
        }
        if (isTextWithImagesType && !(correctAnswers[0].title && correctAnswers[0].asset?.url) ) {
          errors.push({
            name: "answer",
            error: "QUESTIONS.ERRORS.PLEASE_FILL_SELECTED_ANSWER",
          });  
        }
      }

      const entries = answer.single_select || [];
      const requiredEntries = entries // check all

      if (isImagesType) {
        const hasMissingAssets = requiredEntries.some((a) => !a.asset?.url);
        if (hasMissingAssets) {
          errors.push({
            name: "answer",
            error: "QUESTIONS.ERRORS.PLEASE_FILL_ALL_IMAGES",
          });
        }
      }
      if (isTextType) {
        const hasMissingTitles = requiredEntries.some((a) => !a.title);
        if (hasMissingTitles) {
          errors.push({
            name: "answer",
            error: "QUESTIONS.ERRORS.PLEASE_FILL_ALL_TITLES",
          });
        }
      }
      if (isTextWithImagesType) {
        const hasInvalidEntries = requiredEntries.some((a) => !a?.asset?.url || !a.title);
        if (hasInvalidEntries) {
          errors.push({
            name: "answer",
            error: "QUESTIONS.ERRORS.EACH_ENTRY_REQUIRES_ASSET_OR_TITLE",
          });
        }
      }

  }

  if (values.type.value === "multi_select") {
    // @ts-ignore
    const correctAnswers = answer.multi_select?.filter((a) => a?.isCorrect) || [];
    if (correctAnswers.length === 0) {
      errors.push({
        name: "answer",
        error: "QUESTIONS.ERRORS.SELECT_ATLEAST_TWO_CORRECT_ANSWERS",
      });
    }

    const correctAnswersTitle = answer.multi_select?.filter(
      (a) =>
        (a && a?.title?.length > 0) ||
        (a?.asset?.fileName &&
          a?.asset?.fileName.length > 0)
    ) || [];
    if (correctAnswersTitle.length < 2) {
      errors.push({
        name: "answer",
        error: "QUESTIONS.ERRORS.SELECT_TWO_TITLE",
      });
    }
    const value: MultiAnswerTypes  =
    (answer.multi_select?.[0]?.answer as MultiAnswerTypes) ||
    "TEXT_WITH_IMAGES";
  const isImagesType = value == "ONLY_IMAGES" 
  const isTextType = value == "ONLY_TEXT";
  const isTextWithImagesType = value == "TEXT_WITH_IMAGES";

  if (correctAnswers.length) {
    if (isImagesType && correctAnswers.some((a) => !a.asset?.url)) {
      errors.push({
        name: "answer",
        error: "QUESTIONS.ERRORS.PLEASE_FILL_SELECTED_ANSWER_IMAGE",
      });
    }

    if (isTextType && correctAnswers.some((a) => !a.title)) {
      errors.push({
        name: "answer",
        error: "QUESTIONS.ERRORS.PLEASE_FILL_SELECTED_ANSWER_TITLE",
      });
    }

    if (isTextWithImagesType && correctAnswers.some((a) => !a.title && !a.asset?.url)) {
      errors.push({
        name: "answer",
        error: "QUESTIONS.ERRORS.PLEASE_FILL_SELECTED_ANSWER",
      });
    }
  }

  const entries = answer.multi_select || [];
  const requiredEntries = entries // check all
    if (isImagesType) {
      const hasMissingAssets =requiredEntries?.some((a) => !a.asset?.url);
      if (hasMissingAssets) {
        errors.push({
          name: "answer",
          error: "QUESTIONS.ERRORS.PLEASE_FILL_ALL_IMAGES",
        });
      }
    }
    if (isTextType) {
      const hasMissingTitles =requiredEntries?.some((a) => !a.title);
      if (hasMissingTitles) {
        errors.push({
          name: "answer",
          error: "QUESTIONS.ERRORS.PLEASE_FILL_ALL_TITLES",
        });
      }
    }

    if (isTextWithImagesType) {
      const hasInvalidEntries =requiredEntries?.some((a) => !a?.asset?.url || !a.title);
      if (hasInvalidEntries) {
        errors.push({
          name: "answer",
          error: "QUESTIONS.ERRORS.EACH_ENTRY_REQUIRES_ASSET_OR_TITLE",
        });
      }
    }
  }
  if (values.type.value === "mixed_letter") {
    // @ts-ignore
    const words = answer.mixed_letter?.map((a) => a?.word) || [];
    words.forEach(word => {
      if (!word) {
        errors.push({
          name: "answer",
          error: "QUESTIONS.ERRORS.FILL_ALL_WORDS",
        });
      }
      if(!VALID_CHARS_REGEX_FOR_MIXED_LETTER.test(word)) {
        errors.push({
          name: "answer",
          error: "QUESTIONS.ERRORS.MIXED_LETTER_INVALID_CHARS",
        });
      }
    });
   
    if (words.filter((x) => x && x.length > 7).length > 0) {
      errors.push({
        name: "answer",
        error: "QUESTIONS.ERRORS.FILL_ALL_MAX_CHAR",
      });
    }
  }

  if (values.type.value === "open_text") {
    // @ts-ignore
    const answers = answer.open_text?.map((a) => a?.answer) || [];
    if (!answers?.[0]) {
      errors.push({
        name: "answer",
        error: "QUESTIONS.ERRORS.ADD_LEAST_ONE_ANSWER",
      });
    }
    const entries = answer.open_text || [];
    const requiredEntries = entries // check all
    const hasMissingAssets = requiredEntries?.some((a) => !(a.answer) );
    if (hasMissingAssets) {
      errors.push({
        name: "answer",
        error: "QUESTIONS.ERRORS.PLEASE_FILL_ALL_ANSWERS",
      });
    }

  }

  if (values.type.value === "true_false") {
    // @ts-ignore
    const answers = answer.true_false?.map((a) => a?.answer) || [];
    if (!(answers?.[0] == 'TRUE' || answers?.[0] == 'FALSE')) {
      errors.push({
        name: "answer",
        error: "QUESTIONS.ERRORS.SELECT_ONE_TRUE_FALSE_ANSWER",
      });
    }
  }

  if (values.type.value === "correlation") {
    // for each items check if left and right are not empty
    const length = answer.correlation?.length || 2
    for (let index = 0; index <length; index++) {
      const element = answer.correlation?.[index];
      if (index == 0 || index == 1) {
        // @ts-ignore
        if (element?.left === "" || element?.right === "") {
          errors.push({
            name: "answer",
            error: "QUESTIONS.ERRORS.FILL_ALL_PAIRS",
          });
        }
      } else {
        // @ts-ignore
        if (element?.left !== "" && element?.right === "") {
          errors.push({
            name: "answer",
            error: "QUESTIONS.ERRORS.FILL_PAIRS",
          });
        }
      }
    }
    const entries = answer.correlation || [];
  const requiredEntries =  entries // check all
  const hasMissingAssets = requiredEntries?.some((a) => !(a.left && a.right) );
  if (hasMissingAssets) {
    errors.push({
      name: "answer",
      error: "QUESTIONS.ERRORS.FILL_PAIRS",
    });
  }
  }

  if (values.type.value === "free_text") {
    const length = answer.free_text?.length || 2
    for (let index = 0; index < length; index++) {
      const element = answer.free_text?.[index];
      let count = 0;
      // @ts-ignore
      for (const letter of element?.letters ?? []) {
        // Check if option1 or option2 are empty
        if (letter?.option1) {
          count = count + 1;
        }

      }

      if (index == 0 && count < 1) {
        errors.push({
          name: "answer",
          error: "QUESTIONS.ERRORS.FILL_ALL_LETTERS",
        });
      }
    }
    for  (const item of answer?.free_text || []) {
      const option1 =  freeTextValidateOptions(item.letters, 'option1')
      if(!option1.success) {
        errors.push({
          name: "answer",
          error: "QUESTIONS.ERRORS.FREE_TEXT_EMPTY_OPTION"
        })
      }
    }
    for  (const item of answer?.free_text || []) {
      for  (const letter of item.letters) {
        if(letter.isVisible && !letter.option1){
          errors.push({
            name: "answer",
            error: "QUESTIONS.ERRORS.FREE_TEXT_LETTER_CANNOT_BE_SHOWN_WITHOUT_OPTION1"
          })
        }
      }
      if(!item.letters.map(m => m.option1).join("").length) {
        errors.push({
          name: "answer",
          error: "QUESTIONS.ERRORS.FREE_TEXT_OPTION1_CANNOT_BE_EMPTY"
        })
      }
    }

  }

  return errors;
};


function freeTextValidateOptions(data, option) {
  let lastFilledIndex = -1;
  if(data[0].option1.trim() == "") {
    return {
      min: 0,
      max: 0,
      success: false,
      message: `Validation failed: Empty ${option} found between filled values at index 0`
    };
  }

  
  for (let i = 0; i < data.length; i++) {
      if (data[i][option].trim() !== "") {
          if (lastFilledIndex !== -1 && i - lastFilledIndex > 1) {
              return {
                  min: lastFilledIndex + 1,
                  max: i,
                  success: false,
                  message: `Validation failed: Empty ${option} found between filled values at index ${lastFilledIndex} and ${i}`
              };
          }
          lastFilledIndex = i;
      }
  }

  return { success: true, message: "Validation passed" };
}


